import React, { useEffect } from 'react';
import { Button, Card, Item } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/actions';
import * as selectors from '../../../../redux/selectors';
import { bindActionCreators } from 'redux';
import NumberFormat from 'react-number-format';
import SelectListingModal from '../../listings/SelectListingModal';
import EditListingModal from '../../listings/EditListingModal';
import * as api from './../../../../api/showcaseApi';

/**
 * ShowcaseAdSlot
 *  - items: showcaseAdSlotItems:
 *
 * showcaseAdSlotItem: {
 * - item: showcaseFirmItem
 * }
 */

const AdSlotPageItems = ({ items, formik }) => {
  const handleRemove = item => {
    const selected = formik.values.itemIds.filter(id => id !== item.id);
    formik.setFieldValue('itemIds', selected);
  };

  const [showcaseFirmItems, setShowcaseFirmItems] = React.useState([]);

  useEffect(() => {
    const getItems = async () => {
      const { showcaseFirmItems } = await api.getFirmItemsByFirmId(formik.values.firmIds[0]);
      console.log('showcaseFirmItems', { showcaseFirmItems, slot: formik.values });
      setShowcaseFirmItems(showcaseFirmItems);
    };

    getItems();
  }, [formik.values]);

  console.log({ items });

  const getPage = () => (
    <>
      {showcaseFirmItems?.length && (
        <div className="showcase-forms">
          <SelectListingModal
            trigger={
              <Button
                style={{ marginTop: '1rem', marginBottom: '1rem' }}
                positive
                content="Add Item"
                floated="right"
                icon="plus"
                labelPosition="left"
              />
            }
            slot={formik.values}
            formik={formik}
          />

          <Card fluid>
            <Card.Content>
              <Item.Group divided className="listing-item-group">
                {formik.values.itemIds
                  .map(id => items[id])
                  .filter(item => item)
                  .map((listing, idx) => (
                    <Item key={idx}>
                      <Item.Image size="small" src={listing.imageUrl} />
                      <Item.Content className="listing-body">
                        <Item.Header>{listing.description1}</Item.Header>
                        <Item.Description>
                          <Item.Description>{listing.address}</Item.Description>
                          <Item.Description>{listing.description2}</Item.Description>
                          <Item.Meta>
                            <NumberFormat
                              value={listing.price}
                              displayType={'text'}
                              thousandSeparator={true}
                              prefix={'$'}
                              renderText={(value, props) => <div {...props}>{value}</div>}
                            />
                          </Item.Meta>
                        </Item.Description>
                      </Item.Content>
                      <Item.Content>
                        <Button
                          floated="right"
                          content="Remove"
                          negative
                          basic
                          icon="trash"
                          size="tiny"
                          onClick={() => handleRemove(listing)}
                        />

                        <EditListingModal
                          item={listing}
                          trigger={<Button floated="right" primary content="Edit" basic icon="edit" size="tiny" />}
                        />
                      </Item.Content>
                    </Item>
                  ))}
              </Item.Group>
            </Card.Content>
          </Card>
        </div>
      )}
    </>
  );

  return <>{getPage()}</>;
};

const mapStateToProps = state => ({
  currentAdSlot: selectors.getCurrentAdSlot(state),
  items: selectors.getItemsForFirms(state),
});

const mapDispatchToProps = dispatch => ({
  updateCurrentAdSlotItems: bindActionCreators(actions.adSlot.updateCurrentAdSlotItems, dispatch),
  addListing: bindActionCreators(actions.listing.addListing, dispatch),
  getAdSlotById: bindActionCreators(actions.adSlot.getAdSlotById, dispatch),
  createAdSlot: bindActionCreators(actions.adSlot.addAdSlot, dispatch),
  getItemsForFirms: bindActionCreators(actions.adSlot.getItemsForFirms, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdSlotPageItems);
